/**
 * Lightweight client-side filter for known phishing message patterns.
 * Uses homoglyph normalization to catch obfuscated variants like
 * "[ЅΥЅΤΕΜ ΝΟΤΙϜΙСΑΤΙΟΝ]" that use Cyrillic/Greek lookalike characters.
 */

/* eslint-disable no-useless-escape */
const HOMOGLYPH_MAP = {
  а: 'a',
  е: 'e',
  о: 'o',
  р: 'r',
  с: 'c',
  х: 'x',
  і: 'i',
  ѕ: 's',
  Ѕ: 's',
  А: 'a',
  Е: 'e',
  М: 'm',
  О: 'o',
  С: 'c',
  Т: 't',
  У: 'y',
  т: 't',
  у: 'y',
  α: 'a',
  ε: 'e',
  ο: 'o',
  ι: 'i',
  ν: 'v',
  Α: 'a',
  Ε: 'e',
  Ι: 'i',
  Κ: 'k',
  Μ: 'm',
  Ν: 'n',
  Ο: 'o',
  Ρ: 'p',
  Τ: 't',
  Υ: 'y',
  Χ: 'x',
  Ϝ: 'f',
};
/* eslint-enable no-useless-escape */

const HOMOGLYPH_REGEX = new RegExp(`[${Object.keys(HOMOGLYPH_MAP).join('')}]`, 'g');

function normalizeForFilter(input) {
  return input
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[\u200B-\u200D\uFEFF]/g, '')
    .replace(HOMOGLYPH_REGEX, ch => HOMOGLYPH_MAP[ch] || ch)
    .toLowerCase()
    .trim();
}

const BLOCKED_PREFIXES = ['[system notification]', '[system message]', '[security alert]'];

// eslint-disable-next-line import/prefer-default-export
export function isBlockedMessage(content) {
  if (!content) return false;
  const normalized = normalizeForFilter(content.trim());
  return BLOCKED_PREFIXES.some(prefix => normalized.startsWith(prefix));
}
